<template>
    <div class="view border-box " scroll-x="true" >
        <div v-for="(item,index) in data" :key="index" class="item border-box pointer flex flex-center-sp flex-center-cz" :class="{'active': item.id == value}"
        @click="selectClick(item)" >{{item.name}}</div>
    </div>
</template>

<script>
    export default {
        name:'SelectTag',
        props:{
            data:{},
            value:{},
        },
        watch:{
            value:{
                handler(newValue) {
                    console.log("newValue", newValue);
                    this.val = newValue;
                },
                immediate: true,
                deep: true   //深度监听                
            }
        },
        model: {
            prop: "value",
            event: "change"
        },
        data() {
            return {
                val : null
            }
        },
        methods:{
            selectClick(item) {
                this.val = item.id;
                this.$emit("change", this.val)
            }

        }
    }
</script>

<style scoped>



.view {
  white-space: nowrap;
  background-color: #fff;
  width: 100%;
} 

.item {
    margin-left: 5px;
    margin-right: 5px;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 3px;
    padding-bottom: 3px;
    text-align: center;
    border: 1px solid #36a4fd;
    background: #fff ;
    color:#36a4fd;
    width: 20%;
    border-radius: 20px;
    display: inline-block; /* 或其他Flex布局属性 */
}

.active {
  background: #36a4fd ;
  color: #fff;
}

</style>


// WEBPACK FOOTER //
// src/components/selectTag/SelectTag.vue